import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgFor, CommonModule } from '@angular/common';
import { ControllerDetails, ControllerInfo } from 'src/app/models/common/controller-info.model';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ControllerService } from 'src/app/services/controller.service';
import { AlarmGeneratedResolvedInterface, AlarmStructure, DeviceDetais, FilteredAlarmStructure } from 'src/app/models/common/device-telemetry-model';
import { CustomDatePipe } from './custom-date.pipe';
import { CRITICAL_INFO_MAP, DEFAULT_DEVICE_IMAGE, DEVICE_IMAGE_MAP } from 'src/app/models/common/device-image-map';

@Component({
  selector: 'app-alarm-dashboard',
  standalone: true,
  imports: [NgFor, CommonModule,CustomDatePipe],
  templateUrl: './alarm-dashboard.component.html',
  styleUrl: './alarm-dashboard.component.css'
})
export class AlarmDashboardComponent implements OnInit {
  @Input() showAlarmPopup!:boolean
  @Input() deviceDetails!:DeviceDetais
  @Output() closeModal = new EventEmitter()
  controller_info?:ControllerInfo
  filterdArray:FilteredAlarmStructure = {}
  hasAlarms:boolean = false
  popUp:boolean = false
  isCritical:boolean = false
  alarmData:AlarmStructure[] = []
  allAlarmsCheckbox:boolean = true
  originalOrder = () => 0;
    alarmGeneratedTime:AlarmGeneratedResolvedInterface = {"isAlarmGenerated":true}
    alamResolvedTime:AlarmGeneratedResolvedInterface = {"isAlarmGenerated":false}
    onSubmit:boolean = false
    isHidden:boolean = false
    constructor(private controllerService:ControllerService,private confirmationDialogService: ConfirmationDialogService){}
  
    ngOnInit(): void {
      this.alamResolvedTime.timeZone = this.deviceDetails.timeZone
      this.alarmGeneratedTime.timeZone = this.deviceDetails.timeZone
      this.getAlerts()
    }

    async getAlerts() {
      this.filterdArray = {}
      this.alarmData= await this.controllerService.alarmHistory(this.deviceDetails.controller_uuid,this.deviceDetails.device_id)
      this.hasAlarms = this.alarmData.length > 0;
      if(this.hasAlarms){
          this.alarmData.sort((a:AlarmStructure, b:AlarmStructure) => {
          return b.date_time.localeCompare(a.date_time)
        });
        this.alarmSorting()
    }
    this.popUp = false
    }

    criticalInfoAlarms(alertType:number):string{
      if(alertType == 1){
        return "Critical"
      }
      return "info"
    }

      getImagePath(deviceId: string): string {
        return DEVICE_IMAGE_MAP[deviceId] ?? DEFAULT_DEVICE_IMAGE;
    
      }

      getCriticalInfoPath(alarmType:number){
        return CRITICAL_INFO_MAP[alarmType]
      }
  
    modalClose(){
      this.closeModal.emit(true)
      this.confirmationDialogService.closeDialog(true)
    }
    alarmSorting(filterType?:number){
      this.filterdArray = {} 
      let sortedAlarmList = filterType ? this.alarmData.filter((val)=>{
        return val.alert_type == filterType}) :this.alarmData
      this.hasAlarms = sortedAlarmList.length > 0;
      this.allAlarmsCheckbox = !filterType
      sortedAlarmList.forEach((val:AlarmStructure) => {
        const date:string =  val.date_time.split(" ")[0];
        if(!this.filterdArray[date]){
          this.filterdArray[date] = [val]
        }
        else{
        this.filterdArray[date].push(val)
        }
        
      })
      this.popUp = false
    }

    getAlarms(alarmType?:number){
      this.allAlarmsCheckbox = false
      this.isCritical = alarmType == 1 
      this.alarmSorting(alarmType)

    }
    filterPopUp(){
      this.popUp = true
    }
    }
  
  




